export default class ClientEventListController {
    constructor($routeParams, eventService, clientService) {
        eventService.getByClient({ clientId: $routeParams.id }).then(resp => {
            this.events = resp.data;
        });

        clientService.get($routeParams.id).then(resp => {
            this.client = resp.data;
        });
    }
}


// WEBPACK FOOTER //
// ./src/js/components/clients/clients.event-list.controller.js